export const ConnectionBadge = {
  // FA204 / frank trap — themeFor/agentLabel/stateLabel used to be bare
  // module-scope const read from inside Dot.theme/Label.text/Label.theme
  // (serialized factories); they read as undefined once this component is
  // frank.toJSON'd for platform delivery. Moved into `scope`, called via
  // `el.scope.<name>`.
  scope: {
    // Maps the bridge's agent identifier (sent in `bridge_ready` as
    // `adapter.name`) to a presentable label. Unknown identifiers fall back
    // to the raw value so future adapters surface without a code change.
    agentLabel(agent) {
      if (!agent) return null
      if (agent === 'claude' || agent === 'claude-code') return 'Claude'
      if (agent === 'codex') return 'Codex'
      return String(agent)
    },

    // Connection-state fallback for when the bridge hasn't told us which AI
    // is active yet (still connecting, closed, errored).
    stateLabel(status) {
      if (status === 'connecting') return 'connecting…'
      if (status === 'closed') return 'disconnected'
      if (status === 'error') return 'error'
      return status || 'unknown'
    },

    themeFor(status) {
      if (status === 'open') return 'success'
      if (status === 'connecting') return 'warning'
      if (status === 'error') return 'error'
      return 'transparent'
    }
  },

  flow: 'x',
  gap: 'Y',
  align: 'center',

  Dot: {
    width: 'Y',
    height: 'Y',
    borderRadius: '50%',
    theme: (el, s) => el.scope.themeFor(s.root.bridgeStatus)
  },

  // Show the active AI agent (Claude / Codex / …) when the bridge has
  // reported one — otherwise fall back to the connection-state label so
  // the badge still communicates that something's wrong.
  Label: {
    text: (el, s) => el.scope.agentLabel(s.root.agent) || el.scope.stateLabel(s.root.bridgeStatus),
    fontSize: 'Z1',
    theme: (el, s) => el.scope.themeFor(s.root.bridgeStatus)
  }
}
